import { Section } from './Section';
import './HowItWorksSection.css';

const decisionStages = [
  {
    phase: 'Detect',
    title: '1. See what changed',
    description:
      'The new requirement and the change in available capacity are brought into view immediately.',
  },
  {
    phase: 'Understand',
    title: '2. Understand the impact',
    description:
      'The enterprise can see which inventory, orders, commitments, customers, operations, and resources are affected.',
  },
  {
    phase: 'Govern',
    title: '3. Check what is possible',
    description:
      'Business commitments, quality requirements, regulatory obligations, and internal constraints are considered before alternatives are evaluated.',
  },
  {
    phase: 'Simulate',
    title: '4. Compare the choices',
    description:
      'Different courses of action can be explored to understand their likely effects on availability, cost, fulfillment, capacity, risk, and overall business outcomes.',
  },
  {
    phase: 'Deliberate',
    title: '5. Bring the enterprise together',
    description:
      'Sales, operations, logistics, finance, compliance, and other relevant functions can evaluate the situation from their respective perspectives.',
  },
  {
    phase: 'Recommend',
    title: '6. Make a coordinated decision',
    description:
      'Management receives a clear view of the alternatives, their implications, and the recommended course of actionâ€”rather than having to assemble the answer manually from multiple systems and departments.',
  },
];

export function HowItWorksSection() {
  return (
    <Section id="how-it-works" className="how-it-works-section">
      <div className="how-it-works-section__intro">
        <h2>One decision. The whole enterprise.</h2>
        <h3>When conditions change, the whole picture matters</h3>
        <div className="how-it-works-section__copy">
          <p>
            A new customer requirement arrives while available shipping capacity becomes constrained.
            At the same time, existing commitments are competing for the same inventory and
            operational resources.
          </p>
          <p>
            A decision that looks simple in one department can affect customers, inventory,
            production, logistics, cost, and commitments across the enterprise.
          </p>
          <p>The platform helps the enterprise work through the situation as one connected decision.</p>
        </div>
      </div>
      <ol className="decision-loop">
        {decisionStages.map(({ phase, title, description }) => (
          <li key={phase}>
            <div className="decision-loop__marker" aria-hidden="true" />
            <p className="decision-loop__phase">{phase}</p>
            <h3>{title}</h3>
            <p>{description}</p>
          </li>
        ))}
      </ol>
      <div className="how-it-works-section__closing">
        <p>The system does not simply tell the enterprise what happened.</p>
        <p>
          <strong>
            It helps answer: What should we do next, and what is the best decision for the
            enterprise as a whole?
          </strong>
        </p>
      </div>
    </Section>
  );
}
